/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S7_R4_BodyInputs */

const tr_iletisim_s7_r4_body = /** @type {(inputs: Iletisim_S7_R4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS site sorgulama ve bilgi güvenliği şikayetleri için:`)
};

const en_iletisim_s7_r4_body = /** @type {(inputs: Iletisim_S7_R4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For ETBİS website queries and information security complaints:`)
};

const de_iletisim_s7_r4_body = /** @type {(inputs: Iletisim_S7_R4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die ETBİS-Websiteabfrage und Beschwerden zur Informationssicherheit:`)
};

const ru_iletisim_s7_r4_body = /** @type {(inputs: Iletisim_S7_R4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для проверки сайта в ETBİS и жалоб по информационной безопасности:`)
};

/**
* | output |
* | --- |
* | "For ETBİS website queries and information security complaints:" |
*
* @param {Iletisim_S7_R4_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s7_r4_body = /** @type {((inputs?: Iletisim_S7_R4_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S7_R4_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s7_r4_body(inputs)
	if (locale === "de") return de_iletisim_s7_r4_body(inputs)
	if (locale === "ru") return ru_iletisim_s7_r4_body(inputs)
	return tr_iletisim_s7_r4_body(inputs)
});